<mat-card appearance="outlined">
  <mat-card-content [style.overflow]="'auto'" style="max-height: 300px">
    <span class="row">
      <mat-form-field>
        <mat-label>Suchen</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Begriff eingeben" #input />
      </mat-form-field>
      <mat-checkbox #cbOnlyActiveAddresses class="cbInaktiv-margin" (change)="setActive()" [checked]="onlyActive">
        {{ "MAIN_APP_OBJECTS.nurAktiveAdressenSuchen" | translate }}
      </mat-checkbox>
    </span>

    <div>
      <mat-spinner *ngIf="isLoadingResults" style="margin: 0 auto"></mat-spinner>
      <table mat-table [dataSource]="dataSourceAdressen" style="width: 100%">
        <!-- Nr Column -->
        <ng-container matColumnDef="adrnr">
          <th mat-header-cell *matHeaderCellDef>Nr</th>
          <td mat-cell *matCellDef="let element">{{ element.adressNo }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.name" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
        </ng-container>

        <!-- Vorname Column -->
        <ng-container matColumnDef="vorname">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.vorname" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
        </ng-container>

        <!-- Adresse1 Column -->
        <ng-container matColumnDef="adresse1">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.adresse" | translate }}1
          </th>
          <td mat-cell *matCellDef="let element">{{ element.street1 }}</td>
        </ng-container>

        <!-- Adresse2 Column -->
        <ng-container matColumnDef="adresse2">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.adresse" | translate }}2
          </th>
          <td mat-cell *matCellDef="let element">{{ element.street2 }}</td>
        </ng-container>

        <!-- Plz Column -->
        <ng-container matColumnDef="zip">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.plz" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.zip }}</td>
        </ng-container>

        <!-- Ort Column -->
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.ort" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">{{ element.city }}</td>
        </ng-container>

        <!-- Hauptnummer Column -->
        <ng-container matColumnDef="telefon">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.telefon" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <a href="tel:{{ element.phone01 }}">{{ element.phone01 }}</a>
          </td>
        </ng-container>

        <!-- Natel Column -->
        <ng-container matColumnDef="natel">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.natel" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.attentionOf }}
          </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_OBJECTS.email" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <a href="mailto:{{ element.email }}">{{ element.email }}</a>
          </td>
        </ng-container>

        <!-- Homepage Column -->
        <ng-container matColumnDef="homepage">
          <th mat-header-cell *matHeaderCellDef>
            {{ "MAIN_APP_ADRESSES.homepage" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <a href="tel:{{ element.mobile }}">{{ element.mobile }}</a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedAdrColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedAdrColumns" (click)="highlight(row)" [ngClass]="{ highlight: selectedAdressID == row.adressID }"></tr>
      </table>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <mat-paginator [pageSizeOptions]="[5, 10, 15, 20, 30]" showFirstLastButtons></mat-paginator>
  </mat-card-footer>

  <mat-card appearance="outlined">
    {{ "MAIN_APP_OBJECTS.ansprechpartnerDerAdresse" | translate }}
    <mat-card-content *ngIf="hasAnsprechPartner == 1" [style.overflow]="'auto'">
      <div>
        <table mat-table [dataSource]="dataSourceAnsprechPartner" style="width: 100%">
          <!-- Hauptansprechpartner Column -->
          <ng-container matColumnDef="ha">
            <th mat-header-cell *matHeaderCellDef>HA</th>
            <td mat-cell *matCellDef="let element">
              <mat-radio-button [name]="element.adresseID" [value]="element.adresseID" [checked]="element.hauptAnsprechpartner == 1" (change)="setAnsprechpartner(element, $event.value)">
              </mat-radio-button>
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              {{ "MAIN_APP_OBJECTS.name" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <!-- Vorname Column -->
          <ng-container matColumnDef="vorname">
            <th mat-header-cell *matHeaderCellDef>
              {{ "MAIN_APP_OBJECTS.vorname" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.vorname }}</td>
          </ng-container>

          <!-- Zuhanden Column -->
          <ng-container matColumnDef="zuhanden">
            <th mat-header-cell *matHeaderCellDef>
              {{ "MAIN_APP_OBJECTS.zuhanden" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.zuhanden }}</td>
          </ng-container>

          <!-- Briefanrede Column -->
          <ng-container matColumnDef="briefanrede">
            <th mat-header-cell *matHeaderCellDef>
              {{ "MAIN_APP_ADRESSES.briefanrede" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.briefanrede }}
            </td>
          </ng-container>

          <!-- Telefon Column -->
          <ng-container matColumnDef="telefon">
            <th mat-header-cell *matHeaderCellDef>
              {{ "MAIN_APP_OBJECTS.telefon" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <a href="tel:{{ element.phone01 }}">{{ element.telefon }}</a>
            </td>
          </ng-container>

          <!-- Natel Column -->
          <ng-container matColumnDef="natel">
            <th mat-header-cell *matHeaderCellDef>
              {{ "MAIN_APP_OBJECTS.natel" | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
              <a href="tel:{{ element.phone01 }}">{{ element.natel }}</a>
            </td>
          </ng-container>

          <!-- Email Column -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>
              {{ "MAIN_APP_OBJECTS.email" | translate }}il
            </th>
            <td mat-cell *matCellDef="let element">
              <a href="mailto:{{ element.email }}">{{ element.email }}</a>
            </td>
          </ng-container>

          <!-- AnsprechInfo Column -->
          <ng-container matColumnDef="info">
            <th mat-header-cell *matHeaderCellDef>AnsprechInfo</th>
            <td mat-cell *matCellDef="let element">
              {{ element.ansprechInfo }}
            </td>
          </ng-container>

          <!-- Pers Column -->
          <ng-container matColumnDef="pers">
            <th mat-header-cell *matHeaderCellDef style="text-align: center">
              Pers
            </th>
            <td mat-cell *matCellDef="let element" style="text-align: center">
              <mat-checkbox [checked]="element.pers == 1" (change)="setAnsprechPersoenlich(element, $event.checked)">
              </mat-checkbox>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedAnsprechColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedAnsprechColumns" (click)="highlightAP(row)" [ngClass]="{ highlight: selectedAnsprechAdressID == row.adressID }"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-dialog-actions style="margin-bottom: 1.25rem; gap: 0.625rem;">
    <button mat-stroked-button class="confirm" (click)="onNewAddress()" [innerText]="'MAIN_APP_OBJECTS.adresseErfassen' | translate"></button>
    <button mat-stroked-button class="cancel" (click)="onNewPartner()" [disabled]="!selectedAdressID" [innerText]="'MAIN_APP_OBJECTS.ansprechpartnerErfassen' | translate"></button>
  </mat-dialog-actions>
  <span class="row">
	  <mat-form-field>
      <mat-label>{{ "MAIN_APP_OBJECTS.typ" | translate }}</mat-label>
      <mat-select [(ngModel)]="data.objektAdresseZuord.addressType" (ngModelChange)="modelChangeFn($event)" [disabled]="adrTypeDisabled">
        <mat-option *ngFor="let adrType of adressTypes" [value]="adrType.addressTypeNumber">
          {{ adrType.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </span>

  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!canSave" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
